// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/pages/StartPage/StartPage.css */

.start-page {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  padding-bottom: var(--space-xl);
}

/* ---- Direction Selector Section ---- */
.start-page__direction-section {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

/* ---- Leitner Boxes Row (includes shuffle button) ---- */
.leitner-boxes-row {
  display: flex;
  gap: var(--space-sm);
  align-items: stretch;
}

.leitner-box {
  flex: 1 1;
  aspect-ratio: 1 / 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: var(--space-xs);
  border-radius: var(--radius-md);
  border: 2px solid transparent;
  background-color: var(--color-card-white);
  box-shadow: var(--shadow-sm);
  position: relative;
  transition: transform var(--transition-fast), box-shadow var(--transition-fast), border-color var(--transition-fast), background-color var(--transition-fast);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.leitner-box--1 {
  border-color: var(--color-fach-1);
}

.leitner-box--2 {
  border-color: var(--color-fach-2);
}

.leitner-box--3 {
  border-color: var(--color-fach-3);
}

.leitner-box--4 {
  border-color: var(--color-fach-4);
}

.leitner-box--5 {
  border-color: var(--color-fach-5);
}

/* Active / selected compartment */
.leitner-box--active {
  transform: scale(1.05);
  box-shadow: var(--shadow-lg);
}

.leitner-box--active.leitner-box--1 {
  background-color: rgba(229, 57, 53, 0.1);
  border-width: 3px;
}

.leitner-box--active.leitner-box--2 {
  background-color: rgba(255, 143, 0, 0.1);
  border-width: 3px;
}

.leitner-box--active.leitner-box--3 {
  background-color: rgba(253, 216, 53, 0.1);
  border-width: 3px;
}

.leitner-box--active.leitner-box--4 {
  background-color: rgba(102, 187, 106, 0.1);
  border-width: 3px;
}

.leitner-box--active.leitner-box--5 {
  background-color: rgba(66, 165, 245, 0.1);
  border-width: 3px;
}

.leitner-box:active {
  transform: scale(0.96);
}

.leitner-box--active:active {
  transform: scale(1.02);
}

.leitner-box__count {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-extrabold);
  line-height: 1;
}

.leitner-box--1 .leitner-box__count {
  color: var(--color-fach-1);
}

.leitner-box--2 .leitner-box__count {
  color: var(--color-fach-2);
}

.leitner-box--3 .leitner-box__count {
  color: var(--color-fach-3);
}

.leitner-box--4 .leitner-box__count {
  color: var(--color-fach-4);
}

.leitner-box--5 .leitner-box__count {
  color: var(--color-fach-5);
}

.leitner-box__label {
  font-size: 0.55rem;
  color: var(--color-text-light);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1;
}

/* ---- Shuffle Button (icon-only square, inline with compartments) ---- */
.shuffle-btn {
  flex: 1 1;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  border: 2.5px solid var(--color-border);
  background-color: var(--color-card-white);
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  box-shadow: var(--shadow-sm);
  padding: 0;
}

.shuffle-btn:active {
  transform: scale(0.93);
}

/* ---- Shuffle Button (icon-only square, inline with compartments) ---- */
.shuffle-btn {
  flex: 1 1;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  border: 2.5px solid var(--color-border);
  background-color: var(--color-card-white);
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  box-shadow: var(--shadow-sm);
  padding: 0;
}

.shuffle-btn:active {
  transform: scale(0.93);
}

.shuffle-btn__icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform var(--transition-normal);
}

.shuffle-btn__icon svg {
  width: 20px;
  height: 20px;
  fill: currentColor;
}

.shuffle-btn--active .shuffle-btn__icon {
  animation: shuffle-spin 0.4s ease-out;
}

@keyframes shuffle-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

/* ---- Shuffle Prompt Toast ---- */
.shuffle-prompt {
  background-color: var(--color-wood-dark);
  color: var(--color-text-on-wood);
  padding: var(--space-sm) var(--space-md);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  text-align: center;
  animation: shuffle-prompt-fade 2.5s ease-out forwards;
}

@keyframes shuffle-prompt-fade {
  0% {
    opacity: 0;
    transform: translateY(4px);
  }

  10% {
    opacity: 1;
    transform: translateY(0);
  }

  80% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

/* ---- Card Counter ---- */
.card-counter {
  text-align: center;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
  padding: var(--space-xs) 0;
}

/* ---- Action Buttons Row ---- */
.action-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-sm);
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  padding: var(--space-md) var(--space-lg);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  border: 1.5px solid var(--color-border);
  background-color: var(--color-card-white);
  color: var(--color-text-primary);
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
}

.action-btn:active {
  background-color: var(--color-progress-bg);
  box-shadow: none;
  transform: scale(0.98);
}

.action-btn__icon {
  font-size: var(--font-size-lg);
}`, "",{"version":3,"sources":["webpack://./src/pages/StartPage/StartPage.css"],"names":[],"mappings":"AAAA,2FAA2F;;AAE3F;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,wBAAwB;EACxB,+BAA+B;EAC/B,6BAA6B;EAC7B,yCAAyC;EACzC,4BAA4B;EAC5B,kBAAkB;EAClB,6JAA6J;EAC7J,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,wCAAwC;EACxC,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,uCAAuC;EACvC,yCAAyC;EACzC,kCAAkC;EAClC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0EAA0E;AAC1E;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,uCAAuC;EACvC,yCAAyC;EACzC,kCAAkC;EAClC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,mCAAmC;AACnC;EACE,wCAAwC;EACxC,gCAAgC;EAChC,wCAAwC;EACxC,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,wCAAwC;EACxC,+BAA+B;EAC/B,gCAAgC;EAChC,wCAAwC;EACxC,uCAAuC;EACvC,yCAAyC;EACzC,gCAAgC;EAChC,4BAA4B;EAC5B,eAAe;EACf,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/pages/StartPage/StartPage.css */\n\n.start-page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  padding-bottom: var(--space-xl);\n}\n\n/* ---- Direction Selector Section ---- */\n.start-page__direction-section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n}\n\n/* ---- Leitner Boxes Row (includes shuffle button) ---- */\n.leitner-boxes-row {\n  display: flex;\n  gap: var(--space-sm);\n  align-items: stretch;\n}\n\n.leitner-box {\n  flex: 1;\n  aspect-ratio: 1 / 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  padding: var(--space-xs);\n  border-radius: var(--radius-md);\n  border: 2px solid transparent;\n  background-color: var(--color-card-white);\n  box-shadow: var(--shadow-sm);\n  position: relative;\n  transition: transform var(--transition-fast), box-shadow var(--transition-fast), border-color var(--transition-fast), background-color var(--transition-fast);\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.leitner-box--1 {\n  border-color: var(--color-fach-1);\n}\n\n.leitner-box--2 {\n  border-color: var(--color-fach-2);\n}\n\n.leitner-box--3 {\n  border-color: var(--color-fach-3);\n}\n\n.leitner-box--4 {\n  border-color: var(--color-fach-4);\n}\n\n.leitner-box--5 {\n  border-color: var(--color-fach-5);\n}\n\n/* Active / selected compartment */\n.leitner-box--active {\n  transform: scale(1.05);\n  box-shadow: var(--shadow-lg);\n}\n\n.leitner-box--active.leitner-box--1 {\n  background-color: rgba(229, 57, 53, 0.1);\n  border-width: 3px;\n}\n\n.leitner-box--active.leitner-box--2 {\n  background-color: rgba(255, 143, 0, 0.1);\n  border-width: 3px;\n}\n\n.leitner-box--active.leitner-box--3 {\n  background-color: rgba(253, 216, 53, 0.1);\n  border-width: 3px;\n}\n\n.leitner-box--active.leitner-box--4 {\n  background-color: rgba(102, 187, 106, 0.1);\n  border-width: 3px;\n}\n\n.leitner-box--active.leitner-box--5 {\n  background-color: rgba(66, 165, 245, 0.1);\n  border-width: 3px;\n}\n\n.leitner-box:active {\n  transform: scale(0.96);\n}\n\n.leitner-box--active:active {\n  transform: scale(1.02);\n}\n\n.leitner-box__count {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-extrabold);\n  line-height: 1;\n}\n\n.leitner-box--1 .leitner-box__count {\n  color: var(--color-fach-1);\n}\n\n.leitner-box--2 .leitner-box__count {\n  color: var(--color-fach-2);\n}\n\n.leitner-box--3 .leitner-box__count {\n  color: var(--color-fach-3);\n}\n\n.leitner-box--4 .leitner-box__count {\n  color: var(--color-fach-4);\n}\n\n.leitner-box--5 .leitner-box__count {\n  color: var(--color-fach-5);\n}\n\n.leitner-box__label {\n  font-size: 0.55rem;\n  color: var(--color-text-light);\n  font-weight: var(--font-weight-semibold);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  line-height: 1;\n}\n\n/* ---- Shuffle Button (icon-only square, inline with compartments) ---- */\n.shuffle-btn {\n  flex: 1;\n  aspect-ratio: 1 / 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md);\n  border: 2.5px solid var(--color-border);\n  background-color: var(--color-card-white);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  box-shadow: var(--shadow-sm);\n  padding: 0;\n}\n\n.shuffle-btn:active {\n  transform: scale(0.93);\n}\n\n/* ---- Shuffle Button (icon-only square, inline with compartments) ---- */\n.shuffle-btn {\n  flex: 1;\n  aspect-ratio: 1 / 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md);\n  border: 2.5px solid var(--color-border);\n  background-color: var(--color-card-white);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  box-shadow: var(--shadow-sm);\n  padding: 0;\n}\n\n.shuffle-btn:active {\n  transform: scale(0.93);\n}\n\n.shuffle-btn__icon {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform var(--transition-normal);\n}\n\n.shuffle-btn__icon svg {\n  width: 20px;\n  height: 20px;\n  fill: currentColor;\n}\n\n.shuffle-btn--active .shuffle-btn__icon {\n  animation: shuffle-spin 0.4s ease-out;\n}\n\n@keyframes shuffle-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(180deg);\n  }\n}\n\n/* ---- Shuffle Prompt Toast ---- */\n.shuffle-prompt {\n  background-color: var(--color-wood-dark);\n  color: var(--color-text-on-wood);\n  padding: var(--space-sm) var(--space-md);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  text-align: center;\n  animation: shuffle-prompt-fade 2.5s ease-out forwards;\n}\n\n@keyframes shuffle-prompt-fade {\n  0% {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n\n  10% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  80% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n/* ---- Card Counter ---- */\n.card-counter {\n  text-align: center;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-secondary);\n  padding: var(--space-xs) 0;\n}\n\n/* ---- Action Buttons Row ---- */\n.action-buttons {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-sm);\n}\n\n.action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n  padding: var(--space-md) var(--space-lg);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-semibold);\n  border: 1.5px solid var(--color-border);\n  background-color: var(--color-card-white);\n  color: var(--color-text-primary);\n  box-shadow: var(--shadow-sm);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.action-btn:active {\n  background-color: var(--color-progress-bg);\n  box-shadow: none;\n  transform: scale(0.98);\n}\n\n.action-btn__icon {\n  font-size: var(--font-size-lg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
